import { render, staticRenderFns } from "./BuyBoxInfoModal.vue?vue&type=template&id=bff35dbe&scoped=true"
import script from "./BuyBoxInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxInfoModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxInfoModal.vue?vue&type=style&index=0&id=bff35dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff35dbe",
  null
  
)

export default component.exports